export default __webpack_public_path__ + "static/p2-4c536669921cd49cb6d2fe09fbd703cd.jpg";